/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslations } from 'next-intl';

import { LogoSVG } from '@components/logo';
import { Newsletter } from '@components/newsletter';
import { SelectorLanguage } from '@components/selector-language';
import { SelectorTheme } from '@components/selector-theme';
import { Box, Button, Container, Text } from '@versumstudios/ui';

import * as Styles from './styles';

export function Footer() {
  const t = useTranslations('footer');

  return (
    <footer>
      <Container css={{ position: 'relative', backgroundColor: '$primaryBackground' }}>
        <Styles.Directory>
          <Styles.Group>
            <Text as="h6">{t('resources')}</Text>
            <nav>
              <Button
                as="a"
                variant="basic"
                href="https://docs.versum.xyz"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('documentation')}
              </Button>

              <Button
                as="a"
                variant="basic"
                href="https://docs.versum.xyz/faq/materia/"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                Materia
              </Button>

              <Button
                as="a"
                variant="basic"
                href="https://docs.versum.xyz/faq/verification/"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                Verification
              </Button>
              {/* <Button
                as="a"
                variant="basic"
                href="https://docs.versum.xyz/docs/roadmap"
                target="_blank"
                rel="noopener noreferrer"shrink
              >
                {t('roadmap')}
              </Button> */}
              {/* <Button
                as="a"
                variant="basic"
                href="https://docs.versum.xyz/help-center"
                target="_blank"
                rel="noopener noreferrer"shrink
              >
                {t('help-center')}
              </Button> */}
              <Button
                as="a"
                variant="basic"
                href="https://status.versum.xyz"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('status')}
              </Button>
            </nav>
          </Styles.Group>
          <Styles.Group>
            <Text as="h6">{t('community')}</Text>
            <nav>
              <Button
                as="a"
                variant="basic"
                href="https://discord.gg/versum"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('discord')}
              </Button>

              <Button
                as="a"
                variant="basic"
                href="https://versumstudios.github.io/legal/code-of-conduct-0.0.0.html"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('code-conduct')}
              </Button>

              <Button
                as="a"
                variant="basic"
                href="https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=feature_request.md&title="
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('suggest-feature')}
              </Button>
              <Button
                as="a"
                variant="basic"
                href="https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=bug_report.md&title="
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('report-bug')}
              </Button>
              {/* <Button as="a" variant="basic" href="emailto:info@versum.xyz" target="_blank" rel="noopener noreferrer" shrink>
                {t('report-content')}
              </Button> */}
            </nav>
          </Styles.Group>
          <Styles.Group>
            <Text as="h6">{t('terms')}</Text>
            <nav>
              <Button
                as="a"
                variant="basic"
                href="https://versumstudios.github.io/legal/terms-of-service-0.0.0.html"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('terms')}
              </Button>

              <Button
                as="a"
                variant="basic"
                href="https://versumstudios.github.io/legal/privacy-policy-0.0.0.html"
                target="_blank"
                rel="noopener noreferrer"
                shrink
              >
                {t('privacy')}
              </Button>

              {false && (
                <Button
                  as="a"
                  variant="basic"
                  href="https://github.com/versumstudios/versum.xyz/blob/develop/CONTRIBUTING.md"
                  target="_blank"
                  rel="noopener noreferrer"
                  shrink
                >
                  {t('contributing')}
                </Button>
              )}
            </nav>
          </Styles.Group>
          <Styles.Group>
            <Text as="h6">{t('newsletter')}</Text>
            <nav>
              <Newsletter placeholder={t('newsletter-placeholder')} cta={t('newsletter-cta')} />
            </nav>
          </Styles.Group>
        </Styles.Directory>
      </Container>

      <Container>
        <Styles.Container>
          <Box
            vertical
            horizontal
            css={{
              flexDirection: 'column-reverse',
              paddingBottom: '$space$3',

              '@bp1': {
                flexDirection: 'unset',
                paddingBottom: 'unset',
              },
            }}
          >
            <Box vertical horizontal>
              <LogoSVG />
              <Text>{t('rights', { year: new Date().getFullYear() })}.</Text>
            </Box>
            {false && <SelectorLanguage />}
          </Box>
          <Box vertical horizontal css={{ '&>*': { marginLeft: '$space$5' } }}>
            <SelectorTheme />
          </Box>
        </Styles.Container>
      </Container>
    </footer>
  );
}
